import { routes } from "src/shared/routes";
import {
  FAQS,
  FooterLinks,
  AnalyticsHeader,
  NavSubmenuLinks,
  TERMS_AND_CONDITION,
  TERMS_AND_CONDITION_ADD_ON,
  PASS_PURCHASE_SUCCESS_MESSAGE,
  REGISTRATION_TERMS_AND_CONDITIONS,
  TERMS_AND_CONDITION_OPT_OUT_RESTRICTED,
} from "./helper";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

import MobileBannerImage from "public/images/coloradorockies/2025-Digital-Ad-Ballpark-Pass-375x550.png";
import BannerImage from "public/images/coloradorockies/2025-Digital-Ad-Ballpark-Pass-Generic-1920x450.png";

export const coloradorockies_pass: TTeamConfig = {
  TEAM_SCHEMA: "coloradorockies_pass",
  TEAM_FULL_NAME: "Colorado Rockies",
  BROWSER_TITLE: "Rockies Ballpark Pass",
  CLIENT_ID: "2aa19bec0e80.seasonshare.corockies-corockies.us",

  TEAM_GLOBAL_SETTINGS: {
    ANALYTICS_HEADER: AnalyticsHeader,
    COLORS_PRIMARY: "#333366",
    COLORS_SECONDARY: "#000000",
    LOGOUT_ON_INVALID_SESSION: false,
    IS_INTERCOM_ENABLED: true,
    DEFAULT_APP_ROUTE: routes.landing,
    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      ADDITIONAL_SUB_MENU_ITEMS: NavSubmenuLinks,
    },

    FOOTER: {
      LINKS: FooterLinks,
      COPYRIGHT_TEXT: `© ${new Date().getFullYear()} MLB Advanced Media, L.P. All rights reserved`,
    },

    ACCOUNT_MANAGER_URL: "https://am.ticketmaster.com/corockies/",
  },

  LANDING_PAGE_SETTINGS: {
    PASS_BANNER: {
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
      PASS_DISPLAY_MODE: "separate",
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      HIDE_PASS_DETAILS: true,
    },

    PASS: {
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
      SUBSCRIBE_BUTTON_TEXT: "Buy Now!",
      SHOW_FAQ_BUTTON: true,
    },

    SHOW_ALL_EVENTS_UNDER_PASS: true,
    SHOW_ALL_PASSES_UNDER_BANNER: true,
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
    },

    ADD_ON: {
      ADD_SERVICE_FEE_TO_PRICE: true,
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  AUTH_PAGE_SETTINGS: {
    PHONE_INPUT_WIDGET: {
      TERMS_AND_CONDITION: <REGISTRATION_TERMS_AND_CONDITIONS />,
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
    },
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LOGO_URL: "https://ss-leagues.s3.amazonaws.com/MLB-3/COL-2.png",
    LANDING_PAGE_STATIC_BANNER_URL: BannerImage.src,
    MOBILE_LANDING_PAGE_STATIC_BANNER_URL: MobileBannerImage.src,
    FOOTER_LOGO_URL: "https://ss-leagues.s3.amazonaws.com/MLB-3/COL-2.png",
    ORDER_SUMMERY_BACKGROUND_URL:
      "https://ss-leagues.s3.amazonaws.com/MLB/Rockies%20Ballpark%20Assets/player-ballpark-pass-header-3-1920x1080.jpg",
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
    PASS_PURCHASE_SUCCESS_MESSAGE,
    TERMS_AND_CONDITION_OPT_OUT_RESTRICTED,
    PRE_PURCHASE_FAQS: FAQS,
    TERMS_AND_CONDITION_ADD_ON,
  },
};
